import { LazyLoadImage } from "react-lazy-load-image-component";

function BlogBanner({ data }) {
  return (
    <section className="hero">
      <LazyLoadImage
        src={data?.blog?.media}
        alt={data?.blog?.name}
        className="hero-image-blog"
        effect="blur"
      />
    </section>
  )
}
export default BlogBanner;